/**
 * Additional services are stored in Mongo with Spanish display names.
 * Map known catalog names to i18n keys so EN (and other) locales show the right label.
 */
const SPANISH_NAME_TO_I18N_KEY = {
  'Limpieza Interior': 'interior_cleaning',
  'Limpieza Exterior': 'exterior_cleaning',
  'Inspección ITV': 'itv_inspection',
  // Allow both catalog variants for this extra so EN invoices don't leak Spanish
  'Paradas Técnicas (Pit Stop)': 'extra_pit_stop_technical',
  'Paradas Técnicas': 'extra_pit_stop_technical',
  Representación: 'representacion',
  'Recuperación (Europa Continental y UK)': 'extra_recovery_continental_uk',
  'Recuperación (Islas Europeas)': 'extra_recovery_islands',
  'Recuperación (Ceuta y Melilla)': 'extra_recovery_ceuta_melilla',
};

/**
 * @param {string} [name]
 * @param {import('i18next').TFunction} t
 * @returns {string}
 */
export function translateAdditionalServiceName(name, t) {
  if (!name || typeof name !== 'string') return name || '';
  const key = SPANISH_NAME_TO_I18N_KEY[name];
  if (!key) return name;
  const translated = t(key);
  return translated === key ? name : translated;
}

/** Labels from driver extra categories / admin charge types (ES/EN mixed from API) */
const DRIVER_EXTRA_NAME_TO_I18N_KEY = {
  'Pit Stop': 'admin_charge_pit_stop',
  Espera: 'admin_charge_espera',
  ITV: 'admin_charge_itv',
  Express: 'admin_charge_express',
  'Recogida Extra': 'admin_charge_recogida_extra',
  'Cambio de Ruta': 'admin_charge_cambio_ruta',
  Otros: 'admin_charge_otros',
  'Paradas Técnicas (Pit Stop)': 'extra_pit_stop_technical',
  'Paradas Técnicas': 'extra_pit_stop_technical',
};

/**
 * @param {string} [name]
 * @param {import('i18next').TFunction} t
 * @returns {string}
 */
export function translateDriverExtraCategoryName(name, t) {
  if (!name || typeof name !== 'string') return name || '';
  const key = DRIVER_EXTRA_NAME_TO_I18N_KEY[name];
  if (!key) return name;
  const translated = t(key);
  return translated === key ? name : translated;
}
